import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../../../shared/animations/page-transitions';

@Component({
	selector: 'copo-dialog-delete-service',
	templateUrl: './dialog-delete-service.component.html',
	styleUrl: './dialog-delete-service.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [

		MatDialogModule,
		TranslateModule,

		MatButtonModule,
	],
})
export class DialogDeleteServiceComponent implements OnInit {
	constructor(

		@Inject(MAT_DIALOG_DATA) public data: string,

		private readonly dialogRef: MatDialogRef<DialogDeleteServiceComponent>
	) {}

	ngOnInit() {
		this.dialogRef.updateSize('60%');
		this.dialogRef.disableClose = true;
	}
}
